import React from 'react';
import {EfficiencyEntry} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useComponent} from '../../component-library';
import {TwoColumnTableCell} from './two-column-table-cell';
import {AppRenderedDisclaimerReference} from '../app-rendered-disclaimer-reference';
import {ExternallyRenderedDisclaimerReference} from '../externally-rendered-disclaimer-reference';

export interface ConsumptionsEmissionsTableProps {
  readonly entry: EfficiencyEntry;
  readonly disclaimer?: string;
  readonly disclaimerReferenceLabelTranslation: string | undefined;
  readonly closeButtonLabel: string;
  readonly includeDisclaimerInEfficiencyLayer: boolean;
}

export function EfficiencyEntryRow({
  entry,
  disclaimer,
  disclaimerReferenceLabelTranslation,
  closeButtonLabel,
  includeDisclaimerInEfficiencyLayer,
}: ConsumptionsEmissionsTableProps): JSX.Element {
  const Text = useComponent('Text');

  return (
    <tr>
      <TwoColumnTableCell isTableHeader={true}>
        <Text tag="span" variant="label">
          {entry.label}
        </Text>
      </TwoColumnTableCell>
      <TwoColumnTableCell isTableHeader={false}>
        <Text tag="span" variant="label" bold>
          {entry.value}
          {disclaimer &&
            (includeDisclaimerInEfficiencyLayer ? (
              <AppRenderedDisclaimerReference
                text={disclaimer}
                closeButtonLabel={closeButtonLabel}
                disclaimerReferenceLabelTranslation={
                  disclaimerReferenceLabelTranslation
                }
              />
            ) : (
              <ExternallyRenderedDisclaimerReference
                text={disclaimer}
                closeButtonLabel={closeButtonLabel}
                disclaimerReferenceLabelTranslation={
                  disclaimerReferenceLabelTranslation
                }
              />
            ))}
        </Text>
      </TwoColumnTableCell>
    </tr>
  );
}
